export {QuickMessage} from './src/index';
export {QuickMessageModule} from './lib-main';

